/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import type { Moment } from 'moment'
import type { WithBillingDetailsProps } from '@/lib/withBillingDetails/types'

export enum ViewBy {
  DAY = 'day',
  MONTH = 'month',
}

export enum ChartType {
  LINE = 'line',
  BAR = 'bar',
}

export enum Dimension {
  CAPACITY = 'capacity',
  DATA_TRANSFER = 'data_transfer',
  STORAGE = 'storage',
}

export type BucketingStrategy = 'daily' | 'monthly'

export interface ChartCostsArgs {
  from: string
  to: string
  bucketingStrategy: BucketingStrategy
}

export interface Filters {
  selectedDeploymentId: string
  viewBy: ViewBy
  chartType: ChartType
  startDate: Moment
  endDate: Moment
}

export interface ConsumerProps {
  organizationId?: string
  selectedDeploymentId?: string
}

export interface StateProps {
  organizationId?: string
  showPrepaidConsumptionUI: boolean
}
export type AllProps = StateProps & WithBillingDetailsProps & ConsumerProps
